export default __webpack_public_path__ + "static/media/K,K.3bb4cea1.mp3";